import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import BufferOptionsItem from 'buffers/BufferOptionsItem';
import AntibodyToolsMetadata from 'molbio/maps/options/AntibodyToolsMetadata';
import {ZoomSlider, ZoomSliderProps} from 'molbio/maps/options/Sliders';
import DisplayOptions from 'settings/visibility-options/DisplayOptions';
import {VisibilityOptions} from 'settings/visibility-options/VisibilityOptions';
import getTestProps from 'test/lib/cypress/getTestProps';

interface Props {
  aminoAcids: string;
  visibilityOptions: VisibilityOptions;
  zoomSliderProps: ZoomSliderProps;
  featureCounts: {annotations: number};
}

function ProteinMapOptions({
  visibilityOptions,
  zoomSliderProps,
  featureCounts,
  aminoAcids,
}: Props): JSX.Element {
  return (
    <div className="reset">
      <div
        className="buffer-options-container"
        {...getTestProps({
          component: 'ProteinMapOptions',
          element: 'root',
        })}
      >
        <BufferOptionsItem>
          <ZoomSlider {...zoomSliderProps} className={css(styles.noShrink)} />
        </BufferOptionsItem>
        <BufferOptionsItem className={css(styles.expander)} />
        <AntibodyToolsMetadata aminoAcids={aminoAcids} visibilityOptions={visibilityOptions} />
        <div className={`buttonGroup ${css(styles.noShrink)}`}>
          <DisplayOptions dropLeft={true} featureCounts={featureCounts} options={visibilityOptions} />
        </div>
      </div>
    </div>
  );
}

const styles = StyleSheet.create({
  noShrink: {
    flexShrink: 0,
  },
  expander: {
    // Normally the banner has a flex value so it expands and pushes the DisplayOptions and SearchButton
    // all the way to the right.
    flex: 1,
  },
});

export default ProteinMapOptions;
